export const SET_SALES = "SET_SALES";
export const RESET_SALES = "RESET_SALES";
export const SET_SPECIFIC_SALES = "SET_SPECIFIC_SALES";
export const RESET_SPECIFIC_SALES = "RESET_SPECIFIC_SALES";
export const SET_SALES_REPORT = "SET_SALES_REPORT";
export const SET_UNPAID_POSTED_INVOICES = "SET_UNPAID_POSTED_INVOICES";
export const SET_CUSTOMER_STATEMENT_REPORT ='SET_CUSTOMER_STATEMENT_REPORT';
